import { render } from "./ApplyRefund.vue?vue&type=template&id=be7b8c9e"
import script from "./ApplyRefund.vue?vue&type=script&lang=js"
export * from "./ApplyRefund.vue?vue&type=script&lang=js"

import "./ApplyRefund.vue?vue&type=style&index=0&id=be7b8c9e&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__